<template>
  <div
    :class="tabActiveClass"
    id="personal"
    role="tabpanel"
    aria-labelledby="personal-tab"
  >
    <h4 class="form-title hide-mobile">{{ transPeralbaPro.item816 }}</h4>
    <hr class="hide-mobile" />
    <div class="row">
      <div class="col-md-6">
        <h5 class="form-subtitle hide-desktop">{{ transPeralbaPro.item820 }}</h5>
      </div>
      <div class="col-md-12">
        <form-input
          fieldName="name"
          :fieldLabel="transPeralbaPro.item821"
          fieldType="text"
          :fieldValue="name"
          :inputPlaceholder="transPeralbaPro.item821"
          :is-required="true"
          :has-error="fieldHasErrors('personalData', 'name')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="surname"
          :fieldLabel="transPeralbaPro.item822"
          fieldType="text"
          :fieldValue="surname"
          :inputPlaceholder="transPeralbaPro.item822"
          :is-required="true"
          :has-error="fieldHasErrors('personalData', 'surname')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="nif"
          :fieldLabel="transPeralbaPro.item823"
          fieldType="text"
          :fieldValue="nif"
          :inputPlaceholder="transPeralbaPro.item823"
          :is-required="true"
          :has-error="fieldHasErrors('personalData', 'nif')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="email"
          :fieldLabel="transPeralbaPro.item793"
          fieldType="email"
          :fieldValue="email"
          :inputPlaceholder="transPeralbaPro.item794"
          :is-required="true"
          :has-error="fieldHasErrors('personalData', 'email')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="mobile"
          :fieldLabel="transPeralbaPro.item824"
          fieldType="telephone"
          :fieldValue="mobile"
          :inputPlaceholder="transPeralbaPro.item824"
          :is-required="true"
          :has-error="fieldHasErrors('personalData', 'mobile')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="phone"
          :fieldLabel="transPeralbaPro.item825"
          fieldType="telephone"
          :fieldValue="phone"
          :inputPlaceholder="transPeralbaPro.item826"
          :has-error="fieldHasErrors('personalData', 'phone')"
          @updateValue="updateFormValue"
        />
      </div>
    </div>
    <div class="w-100" style="height: 100px">
      <button
        type="button"
        class="btn-per-dark mt-4 mb-2"
        @click="$emit('validateRegisterPersonalData')"
        style="float: right">
        {{ transPeralbaPro.item827 }}<i class="fas fa-arrow-right ms-3"></i>
      </button>
    </div>
  </div>
</template>
<script>
import FormInput from "../../../../../components/front/Inputs/FormInput";
import sections from "../../mixins/sections";
export default {
  mixins: [sections],
  components: { FormInput },
  props: [
    "activeTab",
    "name",
    "surname",
    "nif",
    "email",
    "mobile",
    "phone",
    "errors",
    "transPeralbaPro",
  ],
  methods: {
    updateFormValue(event) {
      this.$emit("updateField", event);
    },

    fieldHasErrors(section, fieldName) {
      return this.errors[section].indexOf(fieldName) !== -1;
    },
  },
};
</script>
